import script from "./FinancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./FinancePage.vue?vue&type=script&setup=true&lang=js"

import "./FinancePage.vue?vue&type=style&index=0&id=1652909a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1652909a"]])

export default __exports__